// extracted by mini-css-extract-plugin
export default {"navigation":"index_navigation_sGy8W clearfix"};